(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bron-hair-density"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){
 if(root.dataset.ready)return;root.dataset.ready='1';
 const form=root.querySelector('.hd-form'),image=root.querySelector('.hd-main-image'),radios=[...root.querySelectorAll('input[name="hd_package"]')],submit=root.querySelector('.hd-add'),one=root.querySelector('[data-hd-onetime]'),stickyAdd=root.querySelector('[data-hd-sticky-add]'),error=root.querySelector('[data-hd-error]'),caption=root.querySelector('[data-hd-gallery-caption]');
 const money=new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency||'USD'}),base=window.Shopify?.routes?.root||'/';
 let selected=radios.find(r=>r.checked&&!r.disabled)||radios.find(r=>!r.disabled),busy=false;
 function show(src,alt){if(!src||!image)return;image.src=src;image.removeAttribute('srcset');image.alt=alt;root.querySelectorAll('[data-hd-image]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.hdImage===src?'true':'false'));caption.textContent=src===root.dataset.giftImage?(selected&&Number(selected.value)>=3?selected.value+' bottles in your plan + a free soap bar with your first order.':'Free $20 soap with your first 3- or 6-month subscription order.'):alt==='Application'?'AI-generated application demonstration. Not a customer result.':'';}
 root.querySelectorAll('[data-hd-image]').forEach(b=>b.addEventListener('click',()=>show(b.dataset.hdImage,b.dataset.alt)));
 function choose(r){
  selected=r;r.checked=true;const n=Number(r.value),total=money.format(Number(r.dataset.total)/100),interval=n===1?'month':n+' months';
  form.elements.quantity.value=n;form.elements.selling_plan.value=r.dataset.plan;
  radios.forEach(x=>x.closest('.hd-plan').classList.toggle('is-selected',x===r));
  root.querySelector('[data-hd-total]').textContent=total;root.querySelector('[data-hd-sticky-price]').textContent=total;
  root.querySelector('[data-hd-sticky-terms]').textContent=n+' '+(n===1?'bottle':'bottles')+' · subscription every '+interval;
  root.querySelector('[data-hd-renewal]').textContent=total+' today, then every '+interval+' for '+n+' '+(n===1?'bottle':'bottles')+'. Renews automatically. Skip, pause or cancel before your next charge.';
  one.textContent='One-time purchase: '+n+' '+(n===1?'bottle':'bottles')+' for '+money.format(Number(root.dataset.basePrice)*n/100);
  const giftNote=root.querySelector('[data-hd-gift-note]');if(giftNote)giftNote.hidden=n<3;
  show(n>=3&&root.dataset.giftImage?root.dataset.giftImage:root.dataset.singleImage,n>=3?'Hair Density Serum and free Charcoal Cleanse soap':'BRÖN Hair Density Serum');
 }
 radios.forEach(r=>r.addEventListener('change',()=>choose(r)));if(selected)choose(selected);
 async function add(subscription){
  if(busy||!selected||submit.disabled)return;busy=true;error.hidden=true;
  const n=Number(selected.value),main={id:Number(form.elements.id.value),quantity:n};if(subscription)main.selling_plan=Number(selected.dataset.plan);
  const originals=[submit.innerHTML,one.textContent,stickyAdd.innerHTML];[submit,one,stickyAdd].forEach(b=>{b.disabled=true;b.setAttribute('aria-busy','true')});radios.forEach(r=>r.disabled=true);
  (subscription?submit.firstElementChild:one).textContent='Adding…';stickyAdd.textContent='Adding…';
  try{
   const items=[main];
   if(subscription&&n>=3&&root.dataset.giftId){
    const current=await fetch(base+'cart.js',{headers:{Accept:'application/json'}});if(!current.ok)throw new Error('Please try again. We could not check your gift.');
    const cart=await current.json();if(!cart.items.some(x=>String(x.variant_id)===root.dataset.giftId&&!x.selling_plan_allocation))items.push({id:Number(root.dataset.giftId),quantity:1});
   }
   const res=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
   const data=await res.json();if(!res.ok)throw new Error(data.description||'Unable to add this selection. Please try again.');
   document.dispatchEvent(new CustomEvent('bron:cart:added',{detail:data}));
   submit.firstElementChild.textContent='Added to cart';stickyAdd.textContent='Added to cart';
  }catch(err){error.textContent=err.message;error.hidden=false;error.scrollIntoView({block:'center',behavior:'smooth'});}
  finally{setTimeout(()=>{submit.innerHTML=originals[0];one.textContent=originals[1];stickyAdd.innerHTML=originals[2];[submit,one,stickyAdd].forEach(b=>{b.disabled=false;b.removeAttribute('aria-busy')});radios.forEach(r=>r.disabled=!r.dataset.plan);busy=false;},900);}
 }
 form.addEventListener('submit',e=>{e.preventDefault();add(true)});one.addEventListener('click',()=>add(false));
 const sticky=root.querySelector('[data-hd-sticky]');function positionSticky(){const rect=submit.getBoundingClientRect();sticky.hidden=rect.top<window.innerHeight&&rect.bottom>0;}window.addEventListener('scroll',positionSticky,{passive:true});window.addEventListener('resize',positionSticky);positionSticky();
}
document.querySelectorAll('[data-hd-root]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-hd-root]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bron-hydration-control-gift"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('[data-hydration-gift-choose]');if(!link)return;const hero=document.querySelector('[data-bron-hydration-hero]');if(!hero)return;event.preventDefault();const one=hero.querySelector('[data-bron-mode="one"]');if(one)one.click();const tier=hero.querySelector('[data-bron-purchase][data-qty="3"]');if(tier)tier.click();hero.querySelector('.bron-hero-content').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bron-line-control-gift"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('[data-line-gift-choose]');if(!link)return;const hero=document.querySelector('[data-bron-line-hero]');if(!hero)return;event.preventDefault();const one=hero.querySelector('[data-bron-mode="one"]');if(one)one.click();const tier=hero.querySelector('[data-bron-purchase][data-qty="3"]');if(tier)tier.click();hero.querySelector('.bron-hero-content').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bron-line-control"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('.lc-form');
    if (!form) return;
    const image = root.querySelector('[data-lc-image]');
    const tiers = [...root.querySelectorAll('.lc-tier input')];
    const modes = [...root.querySelectorAll('.lc-mode input')];
    const submit = form.querySelector('[type=submit]');
    const status = root.querySelector('[data-lc-status]');
    const sticky = root.querySelector('[data-lc-sticky]');
    const stickyButton = root.querySelector('[data-lc-sticky-add]');
    const note = root.querySelector('[data-lc-note]');
    const oneNote = note.textContent;
    let busy = false;
    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency || 'USD'});
    const money = value => formatter.format(Number(value) / 100);
    const selected = () => tiers.find(t => t.checked);
    const subscribed = () => modes.some(m => m.checked && m.value === 'sub');
    function setImage(src, alt) {
      if (!image || !src) return;
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      image.src = src; image.alt = alt;
      root.querySelectorAll('[data-lc-view]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.src === src)));
    }
    function sync() {
      const tier = selected(); if (!tier) return;
      const sub = subscribed(); const price = sub ? tier.dataset.subPrice : tier.dataset.price;
      root.classList.toggle('is-sub', sub);
      form.elements.quantity.value = tier.value;
      form.elements.selling_plan.value = sub ? tier.dataset.plan : '';
      form.elements.selling_plan.disabled = !sub;
      tiers.forEach(t => t.closest('label').querySelector('[data-tier-price]').textContent = money(sub ? t.dataset.subPrice : t.dataset.price));
      root.querySelector('[data-lc-total]').textContent = money(price);
      root.querySelector('[data-lc-sticky-price]').textContent = money(price);
      root.querySelector('[data-lc-sticky-info]').textContent = `${tier.dataset.days}-day plan · ${sub ? 'Subscription' : 'One-time'}`;
      note.textContent = sub ? `${money(price)} every ${tier.dataset.days} days for ${tier.value} ${tier.value === '1' ? 'bottle' : 'bottles'}. Renews automatically. Skip, pause, or cancel anytime. No gifts on subscriptions.` : oneNote;
      const hasGift = !sub && tier.value === '3' && root.dataset.gift;
      setImage(hasGift ? root.dataset.bundle : root.dataset.hero, hasGift ? 'Three LINE CONTROL bottles with a free charcoal soap bar' : 'BRÖN LINE CONTROL night serum');
      const disabled = root.dataset.available !== 'true' || (sub && !tier.dataset.plan) || busy;
      submit.disabled = disabled; stickyButton.disabled = disabled;
    }
    tiers.concat(modes).forEach(input => input.addEventListener('change', sync));
    root.querySelectorAll('[data-lc-view]').forEach(button => button.addEventListener('click', () => setImage(button.dataset.src, button.dataset.alt)));
    root.querySelectorAll('[data-lc-gift-cta]').forEach(button => button.addEventListener('click', () => {
      modes.find(m => m.value === 'one').checked = true; tiers.find(t => t.value === '3').checked = true; sync();
      root.querySelector('.lc-buybox').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'start'});
    }));
    async function add(event) {
      event.preventDefault(); if (busy || submit.disabled) return;
      busy = true; sync(); status.textContent = ''; root.querySelector('[data-lc-add-label]').textContent = 'ADDING…';
      const tier = selected(); const sub = subscribed();
      const item = {id:Number(form.elements.id.value), quantity:Number(tier.value)};
      if (sub) item.selling_plan = Number(tier.dataset.plan);
      const items = [item];
      if (!sub && tier.value === '3' && root.dataset.gift) items.push({id:Number(root.dataset.gift),quantity:1});
      try {
        const response = await fetch(root.dataset.cartAdd,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const data = await response.json(); if (!response.ok) throw new Error(data.description || data.message || 'Could not add this plan. Please try again.');
        document.dispatchEvent(new CustomEvent('bron:cart:added',{detail:data}));
        status.replaceChildren(document.createTextNode('Added to your cart. '));
        const link = document.createElement('a'); link.href=root.dataset.cartUrl;link.textContent='View cart';status.append(link);
      } catch(error) { status.textContent = error.message || 'Connection interrupted. Check your cart before trying again.'; }
      finally { busy=false;sync();root.querySelector('[data-lc-add-label]').textContent='GET LINE CONTROL'; }
    }
    form.addEventListener('submit', add);
    stickyButton.addEventListener('click', () => form.requestSubmit());
    const observer = new IntersectionObserver(entries => {const rect=entries[0].boundingClientRect;sticky.hidden=entries[0].isIntersecting || rect.top>0;},{threshold:0});
    observer.observe(submit);
    root.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
    sync();
  }
  document.querySelectorAll('[data-line-control]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-line-control]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bron-oil-sales"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bron-oil-page')) {
  customElements.define('bron-oil-page', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.mode = 'one';
      this.quantity = 1;
      this.busy = false;
      this.strings = JSON.parse(this.querySelector('[data-op-strings]').textContent);
      this.forms = [...this.querySelectorAll('[data-op-form]')];
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:this.dataset.currency || 'USD',minimumFractionDigits:0,maximumFractionDigits:2});
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.addEventListener('click', event => {
        const mode = event.target.closest('[data-op-mode]');
        const quantity = event.target.closest('[data-op-quantity]');
        const photo = event.target.closest('[data-op-photo]');
        if (mode) { this.mode = mode.dataset.opMode; this.sync(); }
        if (quantity) { this.quantity = Number(quantity.dataset.opQuantity); this.sync(); }
        if (photo) this.showPhoto(photo);
        if (event.target.closest('[data-op-offer]')) {
          this.mode = 'one'; this.quantity = 2; this.sync();
          this.querySelector('#oil-offers').scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
          this.forms[0].querySelector('[data-op-quantity="2"]').focus({preventScroll:true});
        }
        if (event.target.closest('[data-op-sticky-add]')) this.add();
      }, options);
      this.addEventListener('keydown', event => {
        const row = event.target.closest('[data-op-quantity]');
        if (!row || !['ArrowUp','ArrowDown','ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        this.quantity = event.key === 'Home' ? 1 : event.key === 'End' ? 2 : this.quantity === 1 ? 2 : 1;
        this.sync();
        row.closest('[role="radiogroup"]').querySelector('[data-op-quantity="'+this.quantity+'"]').focus();
      }, options);
      this.forms.forEach(form => form.addEventListener('submit', event => { event.preventDefault(); this.add(); }, options));
      this.sync();
      const first = this.querySelector('[data-op-buy="top"]');
      const last = this.querySelector('[data-op-buy="bottom"]');
      const sticky = this.querySelector('[data-op-sticky]');
      this.observer = new IntersectionObserver(() => {
        const a = first.getBoundingClientRect();
        const b = last.getBoundingClientRect();
        sticky.hidden = a.bottom > 110 || (b.top < innerHeight && b.bottom > 110);
      }, {threshold:[0,1], rootMargin:'-110px 0px 0px'});
      this.observer.observe(first);
      this.observer.observe(last);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.ready = false; }
    money(cents) { return this.format.format(Number(cents)/100); }
    selectedRow() { return this.forms[0].querySelector('[data-op-quantity="'+this.quantity+'"]'); }
    showPhoto(button) {
      const image = this.querySelector('[data-op-hero-image]');
      image.removeAttribute('srcset');
      image.src = button.dataset.opPhoto;
      image.alt = button.dataset.alt || '';
      this.querySelectorAll('[data-op-photo]').forEach(b => b.setAttribute('aria-pressed',String(b===button)));
    }
    sync() {
      this.dataset.mode = this.mode;
      const selected = this.selectedRow();
      const sub = this.mode === 'sub';
      const price = selected.dataset[sub ? 'sub' : 'one'];
      const selection = this.mode + ':' + this.quantity;
      if (this.lastSelection !== undefined && this.lastSelection !== selection) {
        this.showPhoto(this.querySelector('[data-op-view="' + (!sub && this.quantity === 2 ? 'offer' : 'bottle') + '"]'));
      }
      this.lastSelection = selection;
      this.querySelectorAll('[data-op-mode]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.opMode===this.mode)));
      this.querySelectorAll('[data-op-quantity]').forEach(b => { const checked=Number(b.dataset.opQuantity)===this.quantity; b.setAttribute('aria-checked',String(checked)); b.tabIndex=checked?0:-1; });
      this.forms.forEach(form => {
        form.elements.quantity.value = this.quantity;
        form.elements.selling_plan.value = sub ? selected.dataset.plan : '';
        form.elements.selling_plan.disabled = !sub;
      });
      this.querySelectorAll('[data-op-price]').forEach(e=>e.textContent=this.money(price));
      const terms = sub ? this.strings.sub_terms.replace('__PRICE__',this.money(price)).replace('__DAYS__',selected.dataset.days) : this.strings.one_terms;
      this.querySelectorAll('[data-op-terms]').forEach(e=>e.textContent=terms);
      const key = (this.quantity===1?'one':'two')+(sub?'_sub_selected':'_selected');
      this.querySelector('[data-op-selection]').textContent = this.strings[key];
    }
    async request(path, body) {
      const response = await fetch(this.dataset.root+path,{method:body?'POST':'GET',headers:{'Content-Type':'application/json',Accept:'application/json'},...(body?{body:JSON.stringify(body)}:{})});
      if(!response.ok) throw new Error('Cart request failed');
      return response.json();
    }
    async add() {
      if(this.busy || this.dataset.available !== 'true') return;
      this.busy=true;
      const buttons=[...this.querySelectorAll('[data-op-add],[data-op-sticky-add]')];
      buttons.forEach(b=>b.disabled=true);
      this.querySelectorAll('[data-op-error]').forEach(e=>e.hidden=true);
      this.querySelectorAll('[data-op-label]').forEach(e=>e.textContent=this.strings.adding);
      const row = this.selectedRow();
      const main = {id:Number(this.forms[0].elements.id.value),quantity:this.quantity};
      if(this.mode==='sub') main.selling_plan=Number(row.dataset.plan);
      const wantsGift=this.mode==='one' && this.quantity===2 && this.dataset.giftAvailable==='true';
      try {
        const cart=await this.request('cart.js');
        const items=[main];
        if(wantsGift && !cart.items.some(item=>item.variant_id===Number(this.dataset.gift) && !item.selling_plan_allocation)) {
          items.push({id:Number(this.dataset.gift),quantity:1,properties:{_bron_oil_gift:'2'}});
        }
        const payload=await this.request('cart/add.js',{items});
        let after=await this.request('cart.js');
        const chargedGift=after.items.find(item=>item.properties?._bron_oil_gift && item.final_price>0);
        if(chargedGift) {
          after=await this.request('cart/update.js',{updates:{[chargedGift.key]:0}});
          this.querySelectorAll('[data-op-error]').forEach(e=>{e.hidden=false;e.textContent=this.strings.gift_error;});
        }
        document.dispatchEvent(new CustomEvent('bron:cart:added',{detail:payload}));
        this.querySelectorAll('[data-op-label]').forEach(e=>e.textContent=this.strings.added);
      } catch(error) {
        document.dispatchEvent(new CustomEvent('bron:cart:error'));
        this.querySelectorAll('[data-op-error]').forEach(e=>{e.hidden=false;e.textContent=this.strings.error;});
      } finally {
        this.busy=false;
        buttons.forEach(b=>b.disabled=this.dataset.available!=='true');
        setTimeout(()=>this.querySelectorAll('[data-op-label]').forEach(e=>e.textContent=this.strings.add),1200);
      }
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bron-peptide-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.pep-form'), strings = JSON.parse(root.querySelector('[data-pep-strings]').textContent);
    const modes = [...form.querySelectorAll('[name=pep_mode]')], offers = [...form.querySelectorAll('[name=pep_quantity]')];
    const add = form.querySelector('.pep-add'), error = form.querySelector('[data-pep-error]'), sticky = root.querySelector('[data-pep-sticky]');
    const base = root.dataset.base, money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.currency}).format(n / 100);
    const selected = () => offers.find(r => r.checked), subscribed = () => modes.some(r => r.value === 'sub' && r.checked);
    const format = (text, values) => Object.entries(values).reduce((s,[k,v]) => s.replaceAll('['+k+']',v),text);
    let busy = false;
    function update() {
      const r = selected(), sub = subscribed(), total = Number(sub ? r.dataset.sub : r.dataset.one);
      form.elements.quantity.value = r.value;
      form.elements.selling_plan.value = sub ? r.dataset.plan : '';
      offers.forEach(row => {
        const card = row.closest('.pep-offer');
        card.querySelector('[data-pep-row-price]').textContent = money(Number(sub ? row.dataset.sub : row.dataset.one));
        card.querySelector('[data-pep-compare]').hidden = !sub;
        card.querySelector('.pep-row-renewal').hidden = !sub;
      });
      root.querySelector('[data-pep-total]').textContent = money(total);
      root.querySelector('[data-pep-terms]').textContent = format(sub ? strings.sub : strings.one, {price:money(total),count:r.value,bottles:r.value === '1' ? strings.bottle : strings.bottles,days:r.dataset.days});
      root.querySelector('[data-pep-sticky-price]').textContent = money(total);
      root.querySelector('[data-pep-sticky-terms]').textContent = sub ? format(strings.sub_short,{count:r.value,bottles:r.value === '1' ? strings.bottle : strings.bottles,days:r.dataset.days}) : strings.one_short;
      add.disabled = busy || root.dataset.available !== 'true' || (sub && !r.dataset.plan);
    }
    [...modes,...offers].forEach(r => r.addEventListener('change',update));
    root.querySelectorAll('[data-pep-image]').forEach(b => b.addEventListener('click',() => {
      const img = root.querySelector('.pep-main-image'); img.src = b.dataset.pepImage; img.removeAttribute('srcset'); img.alt = b.dataset.alt;
      root.querySelectorAll('[data-pep-image]').forEach(x => x.setAttribute('aria-pressed',String(x === b)));
      root.querySelector('[data-pep-caption]').hidden = b !== root.querySelectorAll('[data-pep-image]')[2];
    }));
    async function request(path,body) {
      const response = await fetch(base + path,{headers:{Accept:'application/json',...(body ? {'Content-Type':'application/json'} : {})},...(body ? {method:'POST',body:JSON.stringify(body)} : {})});
      const data = await response.json(); if(!response.ok) throw new Error(data.description || strings.error); return data;
    }
    form.addEventListener('submit',async e => {
      e.preventDefault(); if(busy || add.disabled) return;
      busy = true; error.hidden = true; update(); [...modes,...offers].forEach(r => r.disabled = true);
      root.querySelector('[data-pep-add-label]').textContent = strings.adding;
      let changed = false;
      try {
        const r = selected(), sub = subscribed(), variant = Number(form.elements.id.value);
        let cart = await request('cart.js');
        const main = {id:variant,quantity:Number(r.value)}; if(sub) main.selling_plan = Number(r.dataset.plan);
        const n = cart.items.filter(x => x.variant_id === variant).reduce((sum,x) => sum+x.quantity,0) + main.quantity;
        const tier = n >= 3 ? 3 : n >= 2 ? 2 : 1;
        const giftId = Number(tier === 3 ? root.dataset.hydration : tier === 2 ? root.dataset.soap : 0);
        const oldGiftUpdates = {};
        cart.items.filter(x => x.properties?._bron_peptide_gift && x.variant_id !== giftId).forEach(x => oldGiftUpdates[x.key] = 0);
        if(Object.keys(oldGiftUpdates).length) cart = await request('cart/update.js',{updates:oldGiftUpdates});
        const items = [main];
        const existingGift = giftId && cart.items.find(x => x.variant_id === giftId && !x.selling_plan_allocation);
        if(giftId && !existingGift) items.push({id:giftId,quantity:1,properties:{_bron_peptide_gift:String(tier)}});
        await request('cart/add.js',{items}); changed = true;
        if(giftId) {
          const ownCodes = ['PEPTIDE2SOAP0923','PEPTIDE3HYDRATE0923'];
          const existingCodes = (cart.discount_codes || []).map(x => x.code).filter(x => !ownCodes.includes(x.toUpperCase()));
          cart = await request('cart/update.js',{discount:[...existingCodes,ownCodes[tier-2]].join(',')});
          const free = cart.items.some(x => x.variant_id === giftId && !x.selling_plan_allocation && x.final_price === 0);
          if(!free) {
            const updates = {}; cart.items.filter(x => x.properties?._bron_peptide_gift).forEach(x => updates[x.key] = 0);
            if(Object.keys(updates).length) await request('cart/update.js',{updates});
            throw new Error(strings.gift_error);
          }
        }
        document.dispatchEvent(new CustomEvent('bron:cart:added'));
      } catch(err) {
        error.textContent = err.message || strings.error; error.hidden = false;
        if(changed) {
          try {
            const latest = await request('cart.js');
            if(window.bronValidatePeptideGifts) await window.bronValidatePeptideGifts(latest);
          } catch(cleanupError) {
            error.textContent = strings.gift_error;
          }
          document.dispatchEvent(new CustomEvent('bron:cart:added'));
        }
      } finally {
        busy = false; [...modes,...offers].forEach(r => r.disabled = false); root.querySelector('[data-pep-add-label]').textContent = strings.add; update();
      }
    });
    function positionSticky() {const rect = add.getBoundingClientRect();sticky.hidden = rect.bottom > 0;}
    window.addEventListener('scroll',positionSticky,{passive:true}); window.addEventListener('resize',positionSticky);
    update(); positionSticky();
  }
  document.querySelectorAll('[data-pep-shop]').forEach(init);
  document.addEventListener('shopify:section:load',e => e.target.querySelectorAll('[data-pep-shop]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bron-smooth-skin-set"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-ss-data]').textContent);
    const form = root.querySelector('[data-ss-form]');
    const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: data.currency || 'USD' }).format(n / 100);
    const status = root.querySelector('[data-ss-status]');
    const recovery = root.querySelector('[data-ss-recovery]');
    const addButton = root.querySelector('[data-ss-add]');
    let busy = false;
    function refresh() {
      const sub = form.elements.purchase.value === 'subscription';
      const price = sub ? data.sub : data.once;
      root.querySelector('[data-ss-price]').textContent = money(price);
      root.querySelector('[data-ss-sticky-price]').textContent = money(price);
      root.querySelector('[data-ss-sticky-mode]').textContent = sub ? 'Every 30 days · Save 20%' : 'One-time · Save 10%';
      root.querySelector('[data-ss-saving]').textContent = 'Save ' + money(data.retail - price) + ' against regular individual prices.';
      root.querySelector('[data-ss-terms]').textContent = sub ? money(price) + ' every 30 days, plus applicable shipping and tax. Renews automatically. Skip, pause or cancel in your account before the next charge.' : 'One of each full-size product. Set discount applied in your cart.';
    }
    form.addEventListener('change', refresh);
    refresh();
    root.querySelectorAll('[data-ss-photo]').forEach(button => button.addEventListener('click', () => {
      root.querySelector('[data-ss-main]').src = button.dataset.ssPhoto;
      root.querySelector('[data-ss-mobile]').srcset = button.dataset.mobile;
      root.querySelectorAll('[data-ss-photo]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    async function json(url, body) {
      const response = await fetch(data.root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Please try again.');
      return result;
    }
    function added(payload) {
      document.dispatchEvent(new CustomEvent('bron:cart:added', { detail: payload }));
      if (!document.querySelector('[data-bron-cart]')) window.location.assign(data.root + 'cart');
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !data.available) return;
      const sub = form.elements.purchase.value === 'subscription';
      if (sub && !data.subAvailable) return;
      busy = true; addButton.disabled = true; status.textContent = 'Adding your set…'; recovery.hidden = true;
      let didAdd = false;
      document.dispatchEvent(new CustomEvent('bron:cart:adding'));
      try {
        const items = data.products.map(p => ({ id: p.id, quantity: 1, properties: { _bron_set: 'smooth-skin-set' }, ...(sub ? { selling_plan: data.plan } : {}) }));
        const payload = await json('cart/add.js', { items }); didAdd = true;
        let warning = false;
        if (!sub) {
          try {
            const response = await fetch(data.root + 'cart.js', { headers: { Accept: 'application/json' } });
            if (!response.ok) throw new Error();
            const cart = await response.json();
            const existing = (cart.discount_codes || []).map(d => d.code).filter(Boolean);
            const discounted = await json('cart/update.js', { discount: [...new Set([...existing, data.code])].join(',') });
            warning = !(discounted.discount_codes || []).some(d => d.code.toUpperCase() === data.code.toUpperCase() && d.applicable);
          } catch (_) { warning = true; }
        }
        status.textContent = warning ? 'The products are in your cart, but the set discount could not be confirmed. Check your cart total before paying.' : 'Your set is in the cart.';
        recovery.hidden = false;
        added(payload);
      } catch (error) {
        status.textContent = didAdd ? 'Your products were added. Check your cart before trying again.' : error.message || 'Unable to add the set. Please try again.';
        recovery.hidden = !didAdd;
        document.dispatchEvent(new CustomEvent(didAdd ? 'bron:cart:added' : 'bron:cart:error'));
      } finally { busy = false; addButton.disabled = !data.available; }
    });
    root.querySelectorAll('[data-ss-individual]').forEach(button => button.addEventListener('click', async () => {
      if (busy) return;
      busy = true; button.disabled = true;
      const note = button.parentElement.querySelector('.ss-item-status');
      note.textContent = 'Adding…';
      document.dispatchEvent(new CustomEvent('bron:cart:adding'));
      try { const payload = await json('cart/add.js', { items: [{ id: Number(button.dataset.ssIndividual), quantity: 1 }] }); note.textContent = 'Added to your cart.'; added(payload); }
      catch (error) { note.textContent = error.message || 'Please try again.'; document.dispatchEvent(new CustomEvent('bron:cart:error')); }
      finally { busy = false; button.disabled = false; }
    }));
  }
  document.querySelectorAll('[data-smooth-set]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-smooth-set]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
